import CalendarPopupDesk from "@frameworks/web/components/generic/Calendar/CalendarPopupDesk";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { getQueryParameterName } from "../../../utils/urlHelper";
import { getDateInFormat, getFinancialYear, getFinancialYears, previousDay, } from "@domains/utils/reportDates";
import download from "@frameworks/web/assets/images/Reports/common/download.svg";
import GenericTable from "@frameworks/web/components/generic/GenericTable";
import "../../../stylesheets/components/Reports/contractNotes/contractnotes.scss";
import "@frameworks/web/stylesheets/components/Reports/contractNotes/threeLayerfilter.scss";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import DownloadReportPopupDesk from "@frameworks/web/components/generic/DownloadReports/DownloadReportPopupDesk";
import EdModal from "@frameworks/web/components/generic/edModal";
import PopupFail from "../HoldingReports/SMCaseLoadPopup/SmcasePopupFail";
import SuccessPopup from "../HoldingReports/SMCaseLoadPopup/SmcasePopupSuccess";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import PopupLoader from "../HoldingReports/SMCaseLoadPopup/SmcasePopupLoader";
import moment from "moment";
import { EDownloadeEmailReportSearchParamKeys, ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import di from "./di/servicelocator";
import Common_Shimmer from "@frameworks/web/components/features/Markets/Equity/Equityshimmer/common_shimmer";
import { contractNotesFilters } from "./Constants";
import { accountDetails } from "@di";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import { EquityDropdown, } from "@frameworks/web/components/generic/equitydropdown/equitydropdown";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import ToggleSwitch from "@frameworks/web/components/generic/SwitchButton/Switch";
import { threePaths } from "../DpInterest/DpInterestMobileTable";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/web/components/generic/error";
import LoaderLinkPop from "@frameworks/web/components/generic/LoaderLinkPopUp";
import FailureLinkPopUp from "@frameworks/web/components/generic/FailureLinkPopUp";
import { openBase64PDFInNewTab } from "@domains/utils/fileMethods";
import Popup from "reactjs-popup";
import ContractNotesMobile from "./ContractNotesMobile";
import FamilyTaggingMain from "../FamilyTagging/FamilyTaggingReport/FamilyTaggingMain";
const ContractNotes = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { reducersData: contractReportData, commonData: contractReportCommonData, } = useSelector((state) => state.Contract.contract);
    const { reducersData: contractReportCoData, commonData: contractReportCommonCoData, } = useSelector((state) => state.Contract.contractCommodity);
    const device = DeviceContext();
    const CalederRef = React.useRef(null);
    const initStartDate = React.useCallback(() => {
        if (new Date(finYear, 3, 1) > new Date())
            return new Date(finYear - 1, 3, 1);
        return new Date(finYear, 3, 1);
    }, []);
    const URLfromDate = getQueryParameterName("fromDate");
    const URLtoDate = getQueryParameterName("toDate");
    const [accType, setAccType] = useState();
    const [openCalendar, setOpenCalendar] = React.useState(false);
    const [finYear, setFinYear] = React.useState(getFinancialYear(new Date()));
    const [startDate, setStartDate] = React.useState(initStartDate());
    const [endDate, setEndDate] = React.useState(previousDay);
    const [nextFinYear, setNextFinYear] = React.useState(finYear + 1);
    const [showDownloadPopup, setShowDownloadPopup] = useState(false);
    const [showBand, setShowBand] = React.useState(true);
    const [showLoader, setShowLoader] = React.useState(false);
    const [downloadSuccess, setDownloadSuccess] = React.useState(false);
    const [downloadFailureText, setDownloadFailureText] = React.useState(false);
    const [downloadLoaderText, setDownloadLoaderText] = React.useState(false);
    const [downloadFail, setDownloadFail] = React.useState(false);
    const [operation, setOperation] = useState();
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const [pdfLink, setPdfLink] = React.useState("");
    const [payloadLink, setPayloadLink] = React.useState("");
    const [COMEQTOGGLE, setCOMEQTOGGLE] = React.useState(ILoginAccountTypes.EQ);
    const [selectedSegment, setSelectedSegment] = useState({
        title: "",
        value: "",
    });
    const [selectedStatementType, setSelectedStatementType] = React.useState({
        title: "",
        value: "",
    });
    const [selectedFileName, setSelectedFileName] = useState([]);
    const [showFilterAssetDropdown, setshowFilterAssetDropdown] = React.useState(false);
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const [viewPDFOperation, setviewPDFOperation] = useState("");
    const [segmentTypes, setSegmentTypes] = useState([]);
    const [showAllEmails, setShowAllEmails] = React.useState(false);
    const financialYears = getFinancialYears(startDate, endDate);
    const [statementTypes, setStatementTypes] = React.useState([]);
    const contractNotesEqColumn = [
        {
            key: "attId",
            columnName: (React.createElement("div", { className: "customFormSection_field checkboxWrap common-checkbox-new" },
                React.createElement("div", { className: "checkbox" },
                    React.createElement("div", { className: "form-check" },
                        React.createElement("input", { className: "form-check-input h-16 w-16", type: "checkbox", checked: (selectedFileName === null || selectedFileName === void 0 ? void 0 : selectedFileName.length) ===
                                ((_a = contractReportData.contractReport) === null || _a === void 0 ? void 0 : _a.length) &&
                                ((_b = contractReportData.contractReport) === null || _b === void 0 ? void 0 : _b.length) > 0, onChange: (e) => {
                                if (e.target.checked) {
                                    setSelectedFileName(contractReportData.contractReport.map((x) => String(x.attId)));
                                }
                                else {
                                    setSelectedFileName([]);
                                }
                            } }))))),
            arrows: false,
            tdCustomFunction: (value) => {
                const isChecked = selectedFileName === null || selectedFileName === void 0 ? void 0 : selectedFileName.includes(value === null || value === void 0 ? void 0 : value.toString());
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "customFormSection_field checkboxWrap common-checkbox-new" },
                        React.createElement("div", { className: "checkbox" },
                            React.createElement("div", { className: "form-check" },
                                React.createElement("input", { className: "form-check-input", type: "checkbox", value: value, id: value, checked: isChecked, onChange: (e) => {
                                        handleCheck(e);
                                    } }),
                                React.createElement("div", null,
                                    React.createElement("label", { className: "form-check-label DMSansNormal_12_400", htmlFor: value })))))));
            },
        },
        {
            columnName: "Date",
            arrows: true,
            applySorting: true,
            type: "Date",
            onlyOneArrowAtaTime: true,
            key: "fileDate",
            tdCustomFunction: (value) => {
                return value ? value : "-";
            },
        },
        {
            columnName: "Segement",
            arrows: true,
            key: "segment",
            onlyOneArrowAtaTime: true,
            applySorting: true,
            type: "string",
            tdCustomFunction: (value) => {
                return value ? value : "-";
            },
        },
        {
            columnName: "Statement Type",
            arrows: false,
            key: "fileType",
            onlyOneArrowAtaTime: true,
            applySorting: true,
            type: "string",
            tdCustomFunction: (value) => {
                return value ? value : "-";
            },
        },
        {
            columnName: "File Name",
            arrows: false,
            key: "filePath",
            tdCustomFunction: (value) => {
                var filename = value === null || value === void 0 ? void 0 : value.replace(/^.*[\\\/\\\\]/, "").split(".")[0];
                let payload = {
                    path: value,
                };
                return (React.createElement("span", { className: "DMSanN_16_400 txt-underline hand_cursor", onClick: () => viewContractPDF(payload) }, filename));
            },
        },
    ];
    const contractNotesCoColumn = [
        {
            key: "attId",
            columnName: (React.createElement("div", { className: "customFormSection_field checkboxWrap common-checkbox-new" },
                React.createElement("div", { className: "checkbox" },
                    React.createElement("div", { className: "form-check" },
                        React.createElement("input", { className: "form-check-input h-16 w-16", type: "checkbox", checked: (selectedFileName === null || selectedFileName === void 0 ? void 0 : selectedFileName.length) ===
                                ((_c = contractReportCoData.contractCommodity) === null || _c === void 0 ? void 0 : _c.length) &&
                                ((_d = contractReportCoData.contractCommodity) === null || _d === void 0 ? void 0 : _d.length) > 0, onChange: (e) => {
                                if (e.target.checked) {
                                    setSelectedFileName(contractReportCoData.contractCommodity.map((x) => String(x.attId)));
                                }
                                else {
                                    setSelectedFileName([]);
                                }
                            } }))))),
            arrows: false,
            tdCustomFunction: (key) => {
                const isChecked = selectedFileName.includes(key.toString());
                return (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "customFormSection_field checkboxWrap common-checkbox-new" },
                        React.createElement("div", { className: "checkbox" },
                            React.createElement("div", { className: "form-check" },
                                React.createElement("input", { className: "form-check-input", type: "checkbox", value: key, id: key, checked: isChecked, onChange: (e) => {
                                        handleCheck(e);
                                    } }),
                                React.createElement("div", null,
                                    React.createElement("label", { className: "form-check-label DMSansNormal_12_400", htmlFor: key })))))));
            },
        },
        {
            columnName: "Date",
            arrows: true,
            applySorting: true,
            type: "Date",
            onlyOneArrowAtaTime: true,
            key: "fileDate",
            tdCustomFunction: (value) => {
                return value ? value : "-";
            },
        },
        {
            columnName: "Statement Type",
            arrows: false,
            key: "fileType",
            onlyOneArrowAtaTime: true,
            applySorting: true,
            type: "string",
            tdCustomFunction: (value) => {
                return value ? value : "-";
            },
        },
        {
            columnName: "File Name",
            arrows: false,
            key: "filePath",
            tdCustomFunction: (key) => {
                var filename = key === null || key === void 0 ? void 0 : key.replace(/^.*[\\\/\\\\]/, "").split(".")[0];
                let payload = {
                    path: key,
                };
                return (React.createElement("span", { className: "DMSanN_16_400 txt-underline hand_cursor", onClick: () => viewContractPDF(payload) }, filename));
            },
        },
    ];
    const downloadContractRep = (filePathList) => {
        let downloadPayload = {
            pathList: filePathList,
        };
        if ((selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) !== myAccCode)
            downloadPayload[EDownloadeEmailReportSearchParamKeys.ACCOUNT_IDs] =
                selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
        return di.contract.downloadContractPDF(downloadPayload);
    };
    const emailContractRep = (email, filePathList) => {
        if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) {
            let Emailpayload = {
                emailIds: email.emailIds,
                filePath: filePathList,
            };
            if ((selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) !== myAccCode)
                Emailpayload[EDownloadeEmailReportSearchParamKeys.ACCOUNT_IDs] =
                    selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
            else
                Emailpayload.accountId = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
            return di.contract.sendEmailContractPDF(Emailpayload);
        }
    };
    const downloadAndEmailContractNotes = (email, download) => {
        let filePathList = [];
        let reportData = (accType === ILoginAccountTypes.COMEQ &&
            COMEQTOGGLE === ILoginAccountTypes.EQ) ||
            accType === ILoginAccountTypes.EQ
            ? contractReportData.contractReport
            : contractReportCoData.contractCommodity;
        for (let x of reportData)
            if (selectedFileName.find((y) => String(y) === String(x.attId)))
                filePathList.push(x.filePath);
        let downloadResp = downloadCheck ? downloadContractRep(filePathList) : null;
        let emailResp = emailCheck ? emailContractRep(email, filePathList) : null;
        if (downloadCheck && emailCheck)
            Promise.all([downloadResp, emailResp])
                .then((v) => {
                setShowLoader(false);
                if (v)
                    setDownloadSuccess(v.reduce((prevVal, currVal) => prevVal && currVal, true));
                else
                    setDownloadFail(true);
                setSelectedFileName([]); // Clear selectedFileName on success or failure
            })
                .catch((err) => {
                setShowLoader(false);
                setDownloadFail(true);
                setSelectedFileName([]);
            });
        else if (downloadCheck)
            downloadResp
                .then((v) => {
                setShowLoader(false);
                if (v)
                    setDownloadSuccess(v);
                else
                    setDownloadFail(true);
                setSelectedFileName([]);
            })
                .catch((err) => {
                setShowLoader(false);
                setDownloadFail(true);
                setSelectedFileName([]);
            });
        else if (emailCheck)
            emailResp
                .then((v) => {
                setShowLoader(false);
                if (v)
                    setDownloadSuccess(v);
                else
                    setDownloadFail(true);
                setSelectedFileName([]);
            })
                .catch((err) => {
                setShowLoader(false);
                setDownloadFail(true);
                setSelectedFileName([]);
            });
        setShowDownloadPopup(false);
    };
    const toggleShowAllEmails = () => {
        setShowAllEmails(!showAllEmails);
    };
    const modalTitleDwnldEmail = () => {
        if (downloadCheck && emailCheck)
            return "Downloading and Sharing Contract notes";
        if (downloadCheck)
            return "Download Contract notes ";
        if (emailCheck)
            return "Send Contract notes";
    };
    const loaderMessage = () => {
        if (downloadCheck && emailCheck)
            return "Download and Share";
        if (downloadCheck)
            return "download";
        if (emailCheck)
            return "send";
    };
    const FailureMessage = () => {
        if (downloadCheck && emailCheck)
            return "downloading and sharing";
        if (downloadCheck)
            return "downloading";
        if (emailCheck)
            return "sharing";
    };
    const downloadSuccessNode = () => {
        const emailList = di.contract.emailList;
        if (downloadCheck && emailCheck) {
            return (React.createElement("div", { className: "DMSans_16_500  text-center txt_primaryGrey mgt-5 lh-140" },
                "Your Contract notes report is successfully Downloaded and also Shared with",
                device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 ? (emailList.join()) : (React.createElement(React.Fragment, null,
                    emailList.slice(0, 3).join(),
                    React.createElement(GenericTooltip, { placement: "right", button: React.createElement("span", null,
                            "and",
                            " ",
                            React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline" },
                                emailList.length - 3,
                                " More",
                                " ",
                                emailList.length - 3 === 1 ? "email" : "emails")), toolTipText: React.createElement(React.Fragment, null, emailList.slice(3).map((x) => (React.createElement("div", null, x)))), triggerType: "click", toolTipClassName: "download-email-tooltip", externalClassName: "remove-btn-props" }))))) : (React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 || showAllEmails ? (emailList.map((item, index) => (React.createElement("div", { key: index }, index < emailList.length - 1 ? `${item}, ` : item)))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", null, emailList.slice(0, 3).join(", ")),
                    React.createElement("div", null,
                        "and",
                        " ",
                        React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline", onClick: toggleShowAllEmails },
                            emailList.length - 3,
                            " More",
                            " ",
                            emailList.length - 3 === 1 ? "email" : "emails"))))))));
        }
        if (downloadCheck)
            return (React.createElement("div", { className: "DMSans_16_500  text-center txt_primaryGrey" },
                "Your Contract notes report is ",
                React.createElement("br", null),
                " successfully downloaded"));
        if (emailCheck)
            return (React.createElement("div", { className: "DMSans_16_500 text-center txt_primaryGrey" },
                "Your Contract notes report is successfully shared with",
                device && (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 ? (emailList.join()) : (React.createElement(React.Fragment, null,
                    emailList.slice(0, 3).join(),
                    React.createElement(GenericTooltip, { placement: "right", button: React.createElement("span", { className: "" },
                            "and",
                            " ",
                            React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline" },
                                emailList.length - 3,
                                " More",
                                " ",
                                emailList.length - 3 === 1 ? "email" : "emails")), toolTipText: React.createElement(React.Fragment, null, emailList.slice(3).map((x) => (React.createElement("div", null, x)))), triggerType: "click", toolTipClassName: "download-email-tooltip", externalClassName: "remove-btn-props" }))))) : (React.createElement("div", { className: "txt-midnight-blue" }, emailList.length <= 3 || showAllEmails ? (emailList.map((item, index) => (React.createElement("div", { key: index }, index < emailList.length - 1 ? `${item}, ` : item)))) : (React.createElement(React.Fragment, null,
                    React.createElement("div", null, emailList.slice(0, 3).join(", ")),
                    React.createElement("div", null,
                        "and",
                        " ",
                        React.createElement("span", { className: "txt-midnight-blue hand_cursor text-decoration-underline", onClick: toggleShowAllEmails },
                            emailList.length - 3,
                            " More",
                            " ",
                            emailList.length - 3 === 1 ? "email" : "emails"))))))));
    };
    const viewContractPDF = (payload) => {
        const pdfDisplay = payload.path.replace(/^.*[\\\/\\\\]/, "").split(".")[0];
        setPdfLink(pdfDisplay);
        setDownloadLoaderText(true);
        di.contract
            .contractViewPDF(payload)
            .then((val) => {
            setPayloadLink(val.data);
            setviewPDFOperation("success");
            openBase64PDFInNewTab(val === null || val === void 0 ? void 0 : val.data, pdfDisplay);
            setDownloadLoaderText(false);
        })
            .catch((err) => {
            setDownloadLoaderText(false);
            setDownloadFailureText(true);
            setviewPDFOperation("We ran into some technical difficulties, please try again!");
        });
    };
    const handleCheck = (event) => {
        var updatedList = [...selectedFileName];
        if (event.target.checked) {
            updatedList = [...selectedFileName, event.target.value];
        }
        else {
            updatedList.splice(selectedFileName.indexOf(event.target.value), 1);
        }
        setSelectedFileName(updatedList);
    };
    const DownloadSubmitButtonText = () => {
        if ((downloadCheck && emailCheck) || (!downloadCheck && !emailCheck))
            return React.createElement(React.Fragment, null, "Download and Send Report");
        if (downloadCheck)
            return React.createElement(React.Fragment, null, "Download Report");
        if (emailCheck)
            return React.createElement(React.Fragment, null, "Send Report");
    };
    React.useEffect(() => {
        const handleScroll = () => {
            const scrollLimit = 150;
            if (openCalendar) {
                const scrollY = window.scrollY || document.documentElement.scrollTop;
                if (scrollY > scrollLimit) {
                    setOpenCalendar(false);
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [openCalendar]);
    useEffect(() => {
        function handleClickOutside(event) {
            if (CalederRef.current && !CalederRef.current.contains(event.target))
                setOpenCalendar(false);
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [CalederRef]);
    React.useEffect(() => {
        if (URLfromDate && URLtoDate) {
            setStartDate(new Date(URLfromDate));
            setEndDate(new Date(URLtoDate));
            return;
        }
        if (startDate) {
            setStartDate(new Date(startDate));
            setFinYear(getFinancialYear(new Date(startDate)));
        }
        else {
            if (new Date(finYear, 3, 1) > new Date()) {
                setStartDate(new Date(finYear - 1, 3, 1));
            }
            else
                setStartDate(new Date(finYear, 3, 1));
            setFinYear(getFinancialYear(new Date()));
        }
        if (endDate)
            setEndDate(new Date(endDate));
        else
            setEndDate(previousDay);
        accountDetails
            .getAccTyp()
            .then((val) => setAccType(val));
    }, []);
    const getContractEqData = (selectedStatement, selectedSegment) => {
        setSelectedFileName([]);
        if (startDate &&
            endDate &&
            selectedStatement &&
            selectedSegment &&
            (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)) {
            let payload = {
                fromDate: getDateInFormat(startDate, "YYYY-MM-DD"),
                toDate: getDateInFormat(endDate, "YYYY-MM-DD"),
                type: selectedStatement,
                segment: selectedSegment,
                accountId: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
            };
            di.contract.getContractStatement(payload);
        }
    };
    const getContractCoData = (selectedStatement) => {
        setSelectedFileName([]);
        if (startDate && endDate && selectedStatement && (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)) {
            let payload = {
                fromDate: getDateInFormat(startDate, "YYYY-MM-DD"),
                toDate: getDateInFormat(endDate, "YYYY-MM-DD"),
                type: selectedStatement,
                exchange: "NCDEX",
                entity: "EBL",
                accountId: selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode,
            };
            di.contract.getContractCommodity(payload);
        }
    };
    const getSegmentTypeList = (statementType) => {
        let segmentTypes = contractNotesFilters[statementType].list.map((childItem) => {
            let segment = { title: childItem.title, value: childItem.key };
            if (childItem.selected) {
                setSelectedSegment(segment);
                getContractEqData(statementType, segment.value);
            }
            return segment;
        });
        setSegmentTypes(segmentTypes);
    };
    const familyTagApply = (accCodes) => {
        if ((accType === ILoginAccountTypes.COMEQ &&
            COMEQTOGGLE === ILoginAccountTypes.EQ) ||
            accType === ILoginAccountTypes.EQ)
            getContractEqData(selectedStatementType.value, selectedSegment.value);
        else if ((accType === ILoginAccountTypes.COMEQ &&
            COMEQTOGGLE === ILoginAccountTypes.CO) ||
            accType === ILoginAccountTypes.CO)
            getContractCoData(selectedStatementType.value);
    };
    useEffect(() => {
        if (accType) {
            let statementTypes = Object.keys(contractNotesFilters).map((statementType) => ({
                title: statementType,
                value: statementType,
            }));
            if (accType === ILoginAccountTypes.CO ||
                COMEQTOGGLE === ILoginAccountTypes.CO) {
                statementTypes.splice(3, 1);
            }
            setStatementTypes(statementTypes);
            setSelectedStatementType(statementTypes[0]);
        }
    }, [accType, COMEQTOGGLE]);
    useEffect(() => {
        if (selectedStatementType.value) {
            if ((accType === ILoginAccountTypes.COMEQ &&
                COMEQTOGGLE === ILoginAccountTypes.CO) ||
                accType === ILoginAccountTypes.CO) {
                getContractCoData(selectedStatementType.value);
            }
            else {
                getSegmentTypeList(selectedStatementType.value);
            }
        }
    }, [selectedStatementType]);
    React.useEffect(() => {
        if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode)
            familyTagApply(selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode);
    }, [selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode, startDate, endDate]);
    return (React.createElement(GridContainer, { parentClass: "bg_white new-reports-modalBackdrop contract-notes px-15" },
        (device === null || device === void 0 ? void 0 : device.isDesktop) ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mt-42 flexJustifySpaceBetween" },
                React.createElement("div", null,
                    React.createElement("span", { className: "DMSan_28_700 txt-midnight-blue" }, "Contract Notes & Statement")),
                React.createElement("div", { className: "d-flex justify-content-between align-items-center gap-10" },
                    accType === ILoginAccountTypes.COMEQ ? (React.createElement("div", { className: " toggle-ledger-change gap-1 DMSans_16_500 d-flex txt_black_one1" },
                        React.createElement("div", { className: `${COMEQTOGGLE === ILoginAccountTypes.EQ
                                ? "txt_black_one1"
                                : "txt_secondary-gray"}` }, "Equity"),
                        React.createElement("div", null,
                            React.createElement(ToggleSwitch, { switchcolorClass: "midnight-blue normal-mtf", id: "ComEq", name: "ComEq", checked: COMEQTOGGLE === ILoginAccountTypes.EQ ? false : true, onChange: (checked) => {
                                    if (checked) {
                                        setCOMEQTOGGLE(ILoginAccountTypes.CO);
                                    }
                                    else
                                        setCOMEQTOGGLE(ILoginAccountTypes.EQ);
                                }, small: true })),
                        React.createElement("span", { className: COMEQTOGGLE === ILoginAccountTypes.CO
                                ? "txt_black_one1"
                                : "txt_secondary-gray" }, "Commodity"))) : (React.createElement(React.Fragment, null)),
                    React.createElement(FamilyTaggingMain, { hideConsolidated: false }))),
            React.createElement(Row, { className: "mgt-40 " },
                React.createElement(Col, { lg: 6, className: "d-flex align-items-center" },
                    React.createElement("div", { className: "calender-sub-section common-calender-subsection-backColor ", ref: CalederRef },
                        React.createElement("div", { className: "calendar_date" },
                            React.createElement("div", { className: "displayFlex" },
                                React.createElement("div", { className: "fin_year" }, financialYears.label),
                                "\u00A0",
                                React.createElement("div", { className: "datefullClass" }, `(${moment(startDate).format("D-MMM-YY")} to ${moment(endDate).format("D-MMM-YY")})`),
                                React.createElement("div", { className: "calendar_change displayFlex" },
                                    React.createElement("i", { className: "edel-icon-coloured-calendar pe-2" }, Array(7)
                                        .fill("")
                                        .map((i, idx) => (React.createElement("span", { key: idx, className: `path${idx + 1}` })))),
                                    React.createElement("span", { className: "DMSanM_14_500 txt-midnight-blue", onClick: () => setOpenCalendar(!openCalendar) }, "Change")))),
                        React.createElement("div", { className: "tax-calender calendar-icon-set midnightblue-theme" },
                            React.createElement(CalendarPopupDesk, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, startDate: startDate, endDate: endDate, finYear: finYear, setStartDate: setStartDate, setEndDate: setEndDate, setFinYear: setFinYear, customTime: true, setNextFinYear: setNextFinYear, customTimeText: "Custom Date Range" })))),
                React.createElement(Col, { lg: 6, className: "d-center-end gap-10 common-tooltip common-reports-dropdown-new contract-report-dropdowns" },
                    React.createElement(EquityDropdown, { itemlist: statementTypes, defaultVal: true, selectedDefaultVal: selectedStatementType, selectedValue: setSelectedStatementType, externalClassname: "contract-notes-dropdown dpbills-dropdown-new", align: "end" }),
                    ((accType === ILoginAccountTypes.COMEQ &&
                        COMEQTOGGLE === ILoginAccountTypes.EQ) ||
                        accType === ILoginAccountTypes.EQ) && (React.createElement(EquityDropdown, { itemlist: segmentTypes, defaultVal: true, align: "end", selectedDefaultVal: selectedSegment, selectedValue: (segment) => {
                            setSelectedSegment(segment);
                            getContractEqData(selectedStatementType.value, segment.value);
                        }, externalClassname: "contract-notes-dropdown dpbills-dropdown-new" })),
                    selectedFileName.length < 1 ? (React.createElement(React.Fragment, null,
                        React.createElement(Popup, { className: `popup-desk-common`, trigger: React.createElement("div", { className: "common-download" },
                                React.createElement("button", { className: "download-btn", disabled: ((_e = contractReportData.contractReport) === null || _e === void 0 ? void 0 : _e.length) === 0 &&
                                        ((_f = contractReportCoData.contractCommodity) === null || _f === void 0 ? void 0 : _f.length) === 0 },
                                    React.createElement("img", { src: download }),
                                    "Download")), position: "bottom right" },
                            React.createElement("div", { className: "DMSanN_14_400 txt_bloodRed" }, "Select One Or More Report To Download")))) : (React.createElement("div", { className: "common-download" },
                        React.createElement("button", { className: "download-btn", onClick: () => {
                                setShowDownloadPopup(true);
                            }, disabled: ((_g = contractReportData.contractReport) === null || _g === void 0 ? void 0 : _g.length) === 0 &&
                                ((_h = contractReportCoData.contractCommodity) === null || _h === void 0 ? void 0 : _h.length) === 0 },
                            React.createElement("img", { src: download }),
                            "Download"))))),
            ((accType === ILoginAccountTypes.COMEQ &&
                COMEQTOGGLE === ILoginAccountTypes.EQ) ||
                accType === ILoginAccountTypes.EQ) && (React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "p-0" }, (contractReportCommonData === null || contractReportCommonData === void 0 ? void 0 : contractReportCommonData.loader) ? (React.createElement(Common_Shimmer, null)) : contractReportCommonData.errorData.error &&
                    contractReportCommonData.errorData.isOpen ? (React.createElement(ErrorNotification, { error: contractReportCommonData.errorData.error, isOpen: contractReportCommonData.errorData.isOpen, displayType: ErrorDisplayType.INSECTION })) : (React.createElement(React.Fragment, null,
                    React.createElement(GenericTable, { columns: contractNotesEqColumn, data: contractReportData === null || contractReportData === void 0 ? void 0 : contractReportData.contractReport, parentClassName: "common-table-border table contractnotes-table", loader: contractReportCommonData === null || contractReportCommonData === void 0 ? void 0 : contractReportCommonData.loader, shimmer: React.createElement(Common_Shimmer, null) }),
                    ((_j = contractReportData === null || contractReportData === void 0 ? void 0 : contractReportData.contractReport) === null || _j === void 0 ? void 0 : _j.length) === 0 &&
                        !(contractReportCommonData === null || contractReportCommonData === void 0 ? void 0 : contractReportCommonData.loader) ? (React.createElement("div", { className: "error-msg-new-icon" },
                        React.createElement(Errormsg, { customMsg: React.createElement("div", { className: "DMSan_14_700 txt-midnight-blue" },
                                "No results found!",
                                React.createElement("div", { className: "DMSanN_14_400 txt_secondary-gray" }, "Try searching for something else.")), paths: threePaths, icon: "edel-icon-reports-note" }))) : (React.createElement(React.Fragment, null))))))),
            ((accType === ILoginAccountTypes.COMEQ &&
                COMEQTOGGLE === ILoginAccountTypes.CO) ||
                accType === ILoginAccountTypes.CO) && (React.createElement(Row, null,
                React.createElement(Col, { lg: 12, className: "p-0" }, contractReportCommonCoData.loader ? (React.createElement(Common_Shimmer, null)) : contractReportCommonCoData.errorData.error &&
                    contractReportCommonCoData.errorData.isOpen ? (React.createElement(ErrorNotification, { error: contractReportCommonCoData.errorData.error, isOpen: contractReportCommonCoData.errorData.isOpen, displayType: ErrorDisplayType.INSECTION })) : (React.createElement(React.Fragment, null,
                    React.createElement(GenericTable, { columns: contractNotesCoColumn, data: contractReportCoData.contractCommodity, parentClassName: "common-table-border table contractnotes-table", loader: contractReportCommonCoData.loader, shimmer: React.createElement(Common_Shimmer, null) }),
                    ((_k = contractReportCoData === null || contractReportCoData === void 0 ? void 0 : contractReportCoData.contractCommodity) === null || _k === void 0 ? void 0 : _k.length) === 0 &&
                        !contractReportCommonCoData.loader ? (React.createElement("div", { className: "error-msg-new-icon" },
                        React.createElement(Errormsg, { customMsg: React.createElement("div", { className: "DMSan_14_700 txt-midnight-blue" },
                                "No results found!",
                                React.createElement("div", { className: "DMSanN_14_400 txt_secondary-gray" }, "Try searching for something else")), paths: threePaths, icon: "edel-icon-reports-note" }))) : (React.createElement(React.Fragment, null))))))))) : (React.createElement(ContractNotesMobile, { openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, showBand: showBand, setShowBand: setShowBand, finYear: finYear, endDate: endDate, setFinYear: setFinYear, startDate: startDate, setEndDate: setEndDate, setStartDate: setStartDate, setNextFinYear: setNextFinYear, nextFinYear: nextFinYear, downloadContractRep: downloadContractRep, emailContractRep: emailContractRep, setDownloadSuccess: setDownloadSuccess, setShowLoader: setShowLoader, setDownloadFail: setDownloadFail, handleCheck: handleCheck, showLoader: showLoader, downloadSuccess: downloadSuccess, downloadFail: downloadFail, operation: operation, setOperation: setOperation, selectedFileName: selectedFileName, setSelectedFileName: setSelectedFileName, accType: accType, viewContractPDF: viewContractPDF, viewPDFOperation: viewPDFOperation, COMEQTOGGLE: COMEQTOGGLE, setCOMEQTOGGLE: setCOMEQTOGGLE, downloadLoaderText: downloadLoaderText, downloadFailureText: downloadFailureText, pdfLink: pdfLink, setDownloadFailureText: setDownloadFailureText, payloadLink: payloadLink, segmentTypes: segmentTypes, selectedSegment: selectedSegment, setSelectedSegment: (segment) => {
                setSelectedSegment(segment);
                getContractEqData(selectedStatementType.value, segment.value);
            }, selectedStatementType: selectedStatementType, statementTypes: statementTypes, setSelectedStatementType: setSelectedStatementType })),
        device && device.isDesktop && (React.createElement(React.Fragment, null,
            React.createElement(EdModal, { show: showDownloadPopup, setShow: setShowDownloadPopup, size: "modal-md modal-dialog-centered justify-content-center", iconimage: true, iconClass: "gap-8 icon-new-20", icon: "edel-icon-download-color-new", paths: threePaths, modalTitle: "commonnew-modal-download-popup modalDPTitle commonmodal gray-modal report-common-modal", title: "Download Contract Notes Report", showFooter: false, DisableOutsideClickClose: true },
                React.createElement("div", { className: "downloadHoldingDesk taxreport" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-md-12 col-lg-12 downloadHoldingDesk-form common-reports-download-mail" },
                            React.createElement(DownloadReportPopupDesk, { startDate: startDate, endDate: endDate, withEndDate: true, openCalendar: openCalendar, setOpenCalendar: setOpenCalendar, showBand: showBand, setShowBand: setShowBand, setEndDate: setEndDate, setStartDate: setStartDate, resetFields: showDownloadPopup, showLoader: showLoader, setShowLoader: setShowLoader, setDownloadSuccess: setDownloadSuccess, setDownloadFail: setDownloadFail, setOperation: setOperation, submit: downloadAndEmailContractNotes, reportType: undefined, PDF_or_Excel: ReportType.PDF, isAdditionalDeatils: true, isAdditionalMsg: () => "Your statement is password protected, please enter PAN in capital letters. If you belong to Sikkim, then enter the first 4 alphabets of your name in capital letters.", hideExcel: true, showdate: true, setEmailCheck: setEmailCheck, setDownloadCheck: setDownloadCheck, submitBtnText: DownloadSubmitButtonText() }))))),
            showLoader && (React.createElement("div", { className: "modalBackground loader-red-common common-new-modal-designs" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupLoader, { message: `Your Contract notes report is getting prepared to ${loaderMessage()}`, Title: modalTitleDwnldEmail(), isDownloadIcon: true, goBack: () => setShowDownloadPopup(false) })))),
            downloadSuccess && (React.createElement("div", { className: "modalBackground common-new-modal-designs" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(SuccessPopup, { setDownloadSuccess: setDownloadSuccess, Title: modalTitleDwnldEmail(), operation: operation, goBackText: true, pageName: ReportName.CONTRACT, messageReactNode: downloadSuccessNode(), sendBack: true, isDownloadIcon: true, goBack: () => {
                            setShowDownloadPopup(false);
                            setSelectedFileName([]);
                        } })))),
            downloadFail && (React.createElement("div", { className: "modalBackground common-new-modal-designs common-new-popupfail-desk" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(PopupFail, { setDownloadFail: setDownloadFail, Title: modalTitleDwnldEmail(), operation: operation, goBackText: true, pageName: ReportName.CONTRACT, sendBack: true, isDownloadIcon: true, message: `<span class='DMSans_16_500'>We ran in to some technical difficulties,</br>  please try  ${FailureMessage()} the report again !</span>`, goBack: () => {
                            setShowDownloadPopup(false);
                            setSelectedFileName([]);
                        } })))),
            downloadLoaderText && (React.createElement("div", { className: "modalBackground loading-pop-modal" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(LoaderLinkPop, { Title: pdfLink, messageReactNode: React.createElement("span", { className: "DMSans_16_500 txt-Primary-gray" },
                            "Almost there! ",
                            React.createElement("br", null),
                            " You're being redirected to an external link."), link: payloadLink })))),
            downloadFailureText && (React.createElement("div", { className: "modalBackground failed-pop-modal" },
                React.createElement("div", { className: "modalContainer" },
                    React.createElement(FailureLinkPopUp, { Title: pdfLink, messageReactNode: React.createElement("span", { className: `spl-text DMSans_16_500  txt_primaryGrey ` }, "We ran in to some technical difficulties, please try again!"), link: payloadLink, closeDropdown: () => setDownloadFailureText(false), goBackBtn: true }))))))));
};
export default ContractNotes;
